import { render, staticRenderFns } from "./Emailconfig.vue?vue&type=template&id=badffa78&"
import script from "./Emailconfig.vue?vue&type=script&lang=js&"
export * from "./Emailconfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports